export const config = {
  title: 'Elvin Roofing & Siding | Roofing & Exterior Experts in MI 49507',
  meta: {
    description:
      'Elvin Roofing & Siding provides expert roofing and siding services in Michigan. From repairs and replacements to full exterior upgrades, we deliver durable and reliable craftsmanship.',
    keywords: [
      'Elvin Roofing',
      'Roofing Services MI',
      'Siding Installation',
      'Roof Repairs',
      'Roof Replacement',
      'Exterior Upgrades',
      'Michigan Roofing Company',
    ],
    author: 'Elvin Roofing & Siding',
    canonicalUrl: 'https://mybizsolutions.us/',
  },
  sections: {
    header: {
      businessName: 'Elvin Roofing & Siding',
    },
    sectionB: {
      heroTitle: 'Elvin Roofing & Siding',
      heroSubtitle: 'Reliable Roofing & Siding Experts in Michigan',
      learnAboutText: 'Learn About Our Services',
      phoneNumber: '3524806735',
      phoneLabel: '(352) 480-6735',
      heroBackgroundImage:
        'https://media.istockphoto.com/id/184618430/photo/new-construction-home-roof-vinyl-siding.jpg?s=612x612&w=0&k=20&c=Z5RIOfx1sv4xEOhYWXdjkzaKZDxD7kdv9NWWO7eUp-c=',
      cardData: [
        {
          title: 'Roof Installation & Replacement',
          description:
            'Durable and professionally installed roofing systems tailored to your property’s needs.',
        },
        {
          title: 'Siding Installation & Repairs',
          description:
            'Expert siding services that protect and beautify your home’s exterior.',
        },
        {
          title: 'Emergency Leak Repairs',
          description:
            'Quick-response roofing and siding repairs to minimize damage and restore safety.',
        },
      ],
      description:
        'Elvin Roofing & Siding offers comprehensive exterior solutions, including roofing repairs, installations, siding upgrades, and emergency services. Proudly serving the MI 49507 area with quality and integrity.',
    },
    sectionC: {
      servicesTitle: 'Our Services',
      servicesDescription:
        'Explore our expert roofing and siding services designed for residential and commercial clients.',
      cards: [
        {
          title: 'Roof Installation',
          description:
            'We install new roofs with precision and premium materials to ensure long-term durability.',
          imageSrc: 'https://media.istockphoto.com/id/1264003590/photo/caulk-gun.jpg?s=612x612&w=0&k=20&c=cjZR_Kf0TZ48bJlMFWt9Hx15m4VPUsOdxU2Amc8od64=',
          imageAlt: 'Roof Installation',
        },
        {
          title: 'Siding Solutions',
          description:
            'We offer siding installation and repair with options for vinyl, wood, and fiber cement siding.',
          imageSrc: 'https://media.istockphoto.com/id/1731524763/photo/roofer-construction-worker-ensuring-roof-maintenance-with-security-rope.jpg?s=612x612&w=0&k=20&c=5gGkPrxAAYL6A8mAp6gfxHyEwjqeZ-aXqF52TwysF_A=',
          imageAlt: 'Siding Services',
        },
        {
          title: 'Roof Repairs',
          description:
            'From leaks to damaged shingles, our team is ready to repair your roof fast and efficiently.',
          imageSrc: 'https://media.istockphoto.com/id/1257151444/photo/construction-concept.jpg?s=612x612&w=0&k=20&c=OHgYwU4My4seUSRnNRKgzowNl8mi5NXTr3t3G9yPbcs=',
          imageAlt: 'Roof Repairs',
        },
      ],
      otherServicesTitle: 'Additional Services',
      otherServicesList: [
        'Leak Detection',
        'Roof Inspections',
        'Storm Damage Repair',
        'Flashing & Vent Replacement',
        'Gutter Repair & Replacement',
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src: 'https://media.istockphoto.com/id/1127843198/photo/contractor-builder-with-blue-hardhat-repaoiring-roof.jpg?s=612x612&w=0&k=20&c=i_v4mVE_KG5hv5rHUIYrCoNm8r5uIhto1n3qtQatK-c=',
        alt: 'Elvin Roofing & Siding Team',
      },
      aboutText: [
        'Elvin Roofing & Siding is a dependable local contractor based in Michigan, specializing in roofing and siding services for both homes and businesses.',
        'With a commitment to quality, safety, and client satisfaction, we bring years of industry knowledge and hands-on expertise to every project.',
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: 'Elvin Roofing & Siding Logo',
      businessName: 'Elvin Roofing & Siding',
      contact: {
        phone: '3524806735',
        phoneLabel: '(352) 480-6735',
        email: 'elbinzacarias@gmail.com',
        website: 'https://mybizsolutions.us/',
        address: 'MI 49507, USA',
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        twitter: null,
        linkedIn: null,
        youtube: null,
      },
    },
    sectionF: {
      address: 'MI 49507, USA',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2912.4562192785557!2d-85.67272978458036!3d42.92426707915298!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8818566072497a75%3A0x1b4dbd41e50eb3cc!2sGrand%20Rapids%2C%20MI%2049507%2C%20USA!5e0!3m2!1sen!2sus!4v1712608000000!5m2!1sen!2sus',
    },
  },
};

export default config;
